import React from 'react';
import HomeNavBar from '../components/HomeNavBar';
import HomeComponent from '../components/HomeComponent';

function HomePage() {
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(HomeComponent)
  );
}

export default HomePage;
